import React, { useEffect, useMemo } from 'react';
import { useGetApprovalHistoryMutation } from '../../api/vmsSlice';
import { CheckIcon ,CloseIcon} from "../../services/icons";
import { Box, Typography, Chip } from "@mui/material";
import { capitalizeCamelCase, formatDate} from "../../services/functions";
import { DataNotFound } from '../utils';
import "./Trip.css";

const passOn = /passon/i;
const moveTo = /moveto/i;

export default function ApprovalHistory({ tripDetail, checkpointList }) {
  // console.log("tripId", tripDetail);
  // console.log("checkpointList", checkpointList);

  const [getApprovalHistory, { data: approvalHistoryData, isLoading }] = useGetApprovalHistoryMutation();
  const { data: approvalHistoryDetails = [] } = approvalHistoryData || { data: [] };

  useEffect(() => {
    if (tripDetail?._id) {
      getApprovalHistory({ reference_id: tripDetail._id });
    }
  }, [tripDetail, getApprovalHistory]);

  /**
   *Create checkpoint lookup map
   */
  const checkpointMap = useMemo(() => {
    const map = {};
    (checkpointList || []).forEach((step) => {
      step.checkpoints.forEach((cp) => {
        map[cp._id] = cp.displayName;
      });
    });
    return map;
  }, [checkpointList]);

  /**
   *Process approval history
   */
  const processedApprovalHistory = useMemo(() => {
    return approvalHistoryDetails.map((item) => {
      const { approvalHistory, currentProduct, currentCheckpoints } = item;

      return {
        id: approvalHistory.id,
        email: approvalHistory.email,
        userRole: approvalHistory.userRole,
        userRoleId: approvalHistory.userRoleId,
        name: approvalHistory.name,
        action: approvalHistory.action,
        addedOn: approvalHistory.addedOn,
        productName: currentProduct?.productName,
        productId: currentProduct?._id,
        formData : approvalHistory?.formData,
        currentCheckpoint: checkpointMap[currentCheckpoints?.[0]] || "Unknown Checkpoint",
      };
    });
  }, [approvalHistoryDetails, checkpointMap]);

  console.log("processedApprovalHistory", processedApprovalHistory);

  if (isLoading) return <div>Loading approval history...</div>;

  return (
    <div>
      {processedApprovalHistory?.length === 0  ?   <div>
        <DataNotFound text="No approval history available."/>
        </div> :
      processedApprovalHistory?.length > 0 && processedApprovalHistory?.map((item, index) => {
        const { currentCheckpoint, name, id, email, userRole, action, addedOn, productName, formData } = item;
        const userDetail = {name, email, userRole, addedOn : formatDate(addedOn), productName , remark : formData?.remark || '-'};
        return (
          <div key={`${index}-order-${id}`} className="statusHistory-container">
            <div className="statuslayout-container">
              <div className="status-connector-container">
                <div
                  style={index === 0 ? { backgroundColor: "var(--background-color)" } : { backgroundColor: "green" }}
                  className="status-connector-line"
                ></div>
                <div style={{ backgroundColor: "green" }} className="status-connector-circle">
                  {<CheckIcon fontSize={"small"} htmlColor={"#fff"} />}
                </div>
                {index < processedApprovalHistory.length - 1 && (
                  <div
                    style={action === 'Approved' ? { backgroundColor: "green" } : { backgroundColor: "var(--dark-gray-color)" }}
                    className={`status-connector-line bottom-line`}
                  ></div>
                )}
              </div>
              <div className="status-checkpoint-container" style={{flexWrap : "nowrap"}}>
                <div 
                  style={{ backgroundColor: "var(--primary-color)" }} 
                  className="status-clip" 
				        >
					        {currentCheckpoint}
				        </div>
                <div 
                  style={{ backgroundColor:
										(passOn.test(action) || moveTo.test(action))
										? "#1976d2"
										: action === "Approved"
										? "#2e7d32"
										: action === ("Rejected" || "RejectToGateout")
										? "#d32f2f"
										: action === "Hold"
										? "#e6cf07ff"
										: action === "Pending" 
										? "#1976d2"
										: "#757575",
									}} 
                  className="status-clip" 
				        >
					        Action : {action}
				        </div>
              </div>
            </div>
            <Box
              className="statusHistory-detail-content"
              sx={{ position: "relative" }}
              style={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                border: "1px solid var(--primary-color)",
                borderLeft: "4px solid var(--primary-color)",
              }}
            >			
            <div style={{ padding: "0.5rem", borderRadius: "12px", color: "var(--text-color)" }}>
             {Object.entries(userDetail).map(([key, value], i) => (
                <div key={i} className="detail_row">
                  <div className="detail_row_title">{capitalizeCamelCase(key)}</div>
                  <div className="detail_row_value">
                    {capitalizeCamelCase(value) ?? "-"}
                  </div>
                </div>
              ))}
              </div>		
            </Box>
				</div>
        )
      })}
    </div>
  );
}
